import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import Download from '../../MainSection/Download/Download';
import { useDispatch, useSelector } from 'react-redux';
import { loadMaterialTypeDatas, loadSingleMaterialTypeDatas, loadZoneMasterDatas } from '../../../redux/action';
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import SbCancelBtn, { SbFilterBtn } from '../../Buttons/Buttons';
import AddMaterialType from './AddMaterialType';
import MaterialTypeBulkUploadModal from './MaterialTypeBulkUploadModal';
import MaterialTypeTable from './MaterialTypeTable';
import ViewMaterialType from './ViewMaterialType';
import { useLocation } from 'react-router-dom';
import MaterialTypeColumnFilterModal from './MaterialTypeColumnFilterModal';
import searchIcon from '../../../assets/images/Dashboard/search-icon.svg'
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import { Document, Packer, Table, TableRow, TableCell, Paragraph } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';

const MaterialType = () => {
    let dispatch = useDispatch();
    let location = useLocation();

    const { materialTypeData, totalDataCount, singleMaterialTypeData } = useSelector((state) => state.data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

    const [moduleData, setModuleData] = useState(null);

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Find the module data using the moduleId
            const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
            setModuleData(module);
        }
    }, [storedModulePermissions, moduleId]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showViewDetails, setShowViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);

    const [selectedColumns, setSelectedColumns] = useState([
        "MATERIAL TYPE CODE", "MATERIAL TYPE NAME", "DESCRIPTION", "ACTION"
    ]);
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [materialTypeID, setMaterialTypeID] = useState("");

    const materialTypeDatas = () => {
        dispatch(loadMaterialTypeDatas(setLoading, rowsPerPage, page + 1, searchQuery));
    }
    useEffect(() => {
        materialTypeDatas();
    }, [page, rowsPerPage, searchQuery]);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    const handleOpenModal = (materialTypeId) => {
        setIsModalOpen(true);
        if (materialTypeId) {
            dispatch(loadSingleMaterialTypeDatas(materialTypeId));
            setMaterialTypeID(materialTypeId);
        } else {
            setMaterialTypeID("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleOpenViewModal = (materialTypeId) => {
        setShowViewDetails(!showViewDetails);
        if (materialTypeId) {
            dispatch(loadSingleMaterialTypeDatas(materialTypeId));
            setMaterialTypeID(materialTypeId);
        } else {
            setMaterialTypeID("");
        }
    }

    const handleCloseViewModal = () => {
        setShowViewDetails(false)
    }

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    }

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        // Prepare data to be written to Excel (complainEscalationData)
        const dataToExport = materialTypeData?.map(item => ({
            "MATERIAL TYPE CODE": item.MaterialTypeCode || "NA",
            "MATERIAL TYPE NAME": item.Name || "NA",
            "DESCRIPTION": item.MaterialTypeDescription || "NA",
        })) || [];

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Material Type");

        // Generate Excel file and trigger the download
        XLSX.writeFile(wb, 'materialType.xlsx');
    };

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' }); // Landscape for more width

        // Title
        doc.setFontSize(18);
        doc.text("Material Type Data", 14, 20);

        const dataToExport = materialTypeData?.map(item => ([
            item.MaterialTypeCode || "NA",
            item.Name || "NA",
            item.MaterialTypeDescription || "NA",
        ])) || [];

        const columns = [
            { title: "MATERIAL TYPE CODE", dataKey: "MaterialTypeCode" },
            { title: "MATERIAL TYPE NAME", dataKey: "Name" },
            { title: "DESCRIPTION", dataKey: "MaterialTypeDescription" },
        ];

        // Generate table
        doc.autoTable({
            head: [columns],
            body: dataToExport,
            startY: 30,
            tableWidth: 'auto', // Auto-adjust table to fit page
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak',
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: [255, 255, 255],
                halign: 'left',
            },
        });

        // Save PDF
        doc.save('material_type.pdf');
    };

    const handleDownloadWord = () => {
        if (!materialTypeData || materialTypeData.length === 0) {
            console.error("No data available for export.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the Word document
        const dataToExport = materialTypeData.map(item => [
            String(item?.MaterialTypeCode || "NA"),  // Explicitly convert to string
            String(item?.Name || "NA"),  // Explicitly convert to string
            String(item?.MaterialTypeDescription || "NA"),  // Explicitly convert to string
        ]);

        // Define the headers for the table in the Word document
        const headers = [
            "MATERIAL TYPE CODE", "MATERIAL TYPE NAME", "DESCRIPTION",
        ];

        // Create table rows for the document
        const tableRows = [
            // Header Row
            new TableRow({
                children: headers.map(header => new TableCell({ children: [new Paragraph(header)] }))
            }),
            // Data Rows
            ...dataToExport.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        // Create the table
        const table = new Table({
            rows: tableRows
        });

        // Create the document with metadata
        const doc = new Document({
            creator: "Standards Master",
            title: "Material Type Report",
            description: "A detailed report of Material Type.",
            sections: [  // Ensure that sections are properly passed as an array
                {
                    children: [table]
                }
            ]
        });

        // Generate and download the Word document
        Packer.toBlob(doc)
            .then(blob => saveAs(blob, "material_type.docx"))
            .catch(error => {
                console.error("Error generating Word document:", error);
                alert("An error occurred while generating the Word document. Check the console for details.");
            });
    };

    const handlePrint = () => {
        if (!materialTypeData || materialTypeData.length === 0) {
            console.error("No data available for printing.");
            alert("No data to print!");
            return;
        }

        const dataToExport = materialTypeData?.map(item => ([
            item.MaterialTypeCode || "NA",
            item.Name || "NA",
            item.MaterialTypeDescription || "NA",
        ])) || [];

        const headers = [
            "MATERIAL TYPE CODE", "MATERIAL TYPE NAME", "DESCRIPTION",
        ];

        // Create HTML table for printing
        let tableHtml = `
                    <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                        <thead>
                            <tr>
                                ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                            </tr>
                        </thead>
                        <tbody>
                            ${dataToExport.map(row => `
                                <tr>
                                    ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                `;

        // Create a print window
        const printWindow = window.open('', '', 'width=800,height=600');
        printWindow.document.write('<html><head><title>Material Type Report</title>');
        printWindow.document.write('<style>body { font-family: Arial, sans-serif; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<h1>Material Type Report</h1>');
        printWindow.document.write(tableHtml); // Insert the table
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for the document to load

        // Trigger the print dialog after content is loaded
        printWindow.print();
    };

    const handleDownloadImage = () => {
        if (!materialTypeData || materialTypeData.length === 0) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        const dataToExport = materialTypeData?.map(item => ([
            item.MaterialTypeCode || "NA",
            item.Name || "NA",
            item.MaterialTypeDescription || "NA",
        ])) || [];

        const headers = [
            "MATERIAL TYPE CODE", "MATERIAL TYPE NAME", "DESCRIPTION",
        ];

        // Create the table HTML to be rendered
        let tableHtml = `
                            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                                <thead>
                                    <tr>
                                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                                    </tr>
                                </thead>
                                <tbody>
                                    ${dataToExport.map(row => `
                                        <tr>
                                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                                        </tr>
                                    `).join('')}
                                </tbody>
                            </table>
                        `;

        // Create a container div for the table to be captured
        const printContainer = document.createElement('div');
        printContainer.innerHTML = tableHtml;

        // Append the print container to the body (for rendering purposes)
        document.body.appendChild(printContainer);

        // Use html2canvas to convert the table HTML into an image
        html2canvas(printContainer, {
            scale: 2, // Increase the scale to get better image quality (default is 1)
            useCORS: true, // Enable Cross-Origin Resource Sharing (useful if the table includes external images)
            width: printContainer.scrollWidth, // Dynamically set the width of the canvas to fit the content
            height: printContainer.scrollHeight, // Dynamically set the height of the canvas to fit the content
            scrollX: 0, // Ensure that it doesn't pick up the page's scroll position
            scrollY: -window.scrollY // Adjust the scroll position if necessary
        }).then(canvas => {
            // Remove the print container after rendering
            document.body.removeChild(printContainer);

            // Convert canvas to image data URL
            const imgData = canvas.toDataURL('image/png');

            // Create a temporary link to trigger download
            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'material_type_report.png'; // Specify the image file name
            link.click(); // Simulate a click event to trigger the download
        });
    };

    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        materialTypeDatas();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        showDownloadDropdown={true}
                        moduleName="Standards Master"
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Material Type</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={4} className='filters-col'>
                                    <div className='customermanagement-search'>
                                        <Form.Control
                                            type="search"
                                            placeholder='Search'
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <img src={searchIcon} alt="" onClick={handleSearchClick} />
                                    </div>
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {/* {moduleData?.CanCreate === true && */}
                                <SbDropdownButton
                                    // pageName="Material Group"
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />
                                {/* } */}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <MaterialTypeTable
                                handleOpenModal={handleOpenModal}
                                handleOpenViewModal={handleOpenViewModal}
                                selectedColumns={selectedColumns}
                                loading={loading}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                moduleData={moduleData}
                                totalDataCount={totalDataCount}
                                materialTypeData={materialTypeData}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddMaterialType
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    materialTypeDatas={materialTypeDatas}
                    materialTypeID={materialTypeID}
                    singleMaterialTypeData={singleMaterialTypeData}
                />
            }
            {
                showBulkUploadModal && <MaterialTypeBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                // deptData={deptData}
                />
            }
            {showColumnFilterModal && (
                <MaterialTypeColumnFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {/* {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )} */}
            {showViewDetails && (
                <ViewMaterialType
                    showViewDetails={showViewDetails}
                    handleCloseViewModal={handleCloseViewModal}
                    singleMaterialTypeData={singleMaterialTypeData}
                />
            )}
        </div >
    );
};

export default MaterialType;